import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import { useFormik } from "formik";
import { actulizaExtraAction } from "../../../ducks/extrasDuck";
import { ToastMessage } from "../../../global/ToastMessage";
import { actualizarExtraVueloAction, actualizarExtraVueloRegresoAction, obtenerExtrasVueloAction, obtenerExtrasVueloRegresoAction } from "../../../ducks/proveedorAereolineaDuck";
import { Button, Dialog, DialogActions, DialogContent, Grid, InputAdornment, TextField, Tooltip } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import BackDrop from "../../../global/BackDrop";
import ControlledEditor from "../../../global/ControlledEditor"
import { FExtraVueloStyle } from "./styles";
import HeaderModal from "../../../global/headerModal";

const validationSchema = yup.object({
    nombre: yup.string("Ingresa un nombre").required("Nombre es requerido"),
    suplemento: yup
        .number("Ingresa un precio neto")
        .required("Precio neto es requerido"),
})

const initialValues = {
    nombre: "",
    descripcion: "",
    suplemento: 0,
}

const ActualizaExtraVuelo = ({ 
        tipo,
        esRedondo, 
        idExtra = 0, 
        idVueloProveedorExtra = 0, 
        idVueloRedondoExtra = 0, 
        Nombre = "", 
        Precio = 0, 
        Descripcion = "" 
    }) => {
    const dispatch = useDispatch();
    const classes = FExtraVueloStyle();
    
    const { vueloTarget } = useSelector((store) => store.vueloProveedor);
    const [open, setOpen] = useState(false);
    const [isLoad, setIsLoad] = useState(false);
    const [planDescripcion, setPlanDescripcion] = useState("")
    const [descripcion, setDescripcion] = useState(
        "<p><strong>Escribe aquí tu texto</strong></p>"
    )
    
    const LimpiarForm = () => {
        formik.resetForm(initialValues);
        setDescripcion('<p><strong>Escribe aqui tu texto</strong></p>');
    };

    const handleClickOpen = () => {
        setOpen(true)
        LimpiarForm()
        formik.setFieldValue("nombre", Nombre)
        formik.setFieldValue("suplemento", Precio)
        setDescripcion(Descripcion)
    }
      
    const handleClose = () => {
        setOpen(false);
        formik.resetForm();
        setDescripcion("<p><strong>Escribe aquí tu texto</strong></p>");
    };

    const onDescripcionValue = value => {
        setDescripcion(value)
    }
    const onDescripcionPlanValue = value => {
        setPlanDescripcion(value)
    }

      const formik = useFormik({
        initialValues: initialValues,
        validationSchema,
        onSubmit: (values) => {
          setIsLoad(true);
          const payload = { 
            IdExtra: idExtra, 
            Descripcion: descripcion, 
            Nombre: values.nombre 
        };

      dispatch(actulizaExtraAction(payload)).then((Response) => {
        switch (Response.status) {
            case 500:
                ToastMessage.fire({
                    icon: "error",
                    title: "Ha habido un problema de conexión con el servidor",
                });
            break
            case 400:
                ToastMessage.fire({
                    icon: "warning",
                    title: "<strong>Atención</strong>",
                    text: "Al menos un dato no se ha enviado, favor de llenar el registro.",
                });
            break
            default: 
                const extra = { 
                    idVueloProveedorExtra: idVueloProveedorExtra,
                    idVueloProveedor: vueloTarget?.IdVueloProveedor,
                    idExtra: idExtra, 
                    idPaquete: vueloTarget?.Proveedor.IdProveedor,
                    suplemento: Number(values.suplemento), 
                    descripcion: planDescripcion,
                    estatus: true
                };

                const extraRegreso = {
                    idVueloRedondoExtra: idVueloRedondoExtra,
                    idVueloRedondo: vueloTarget?.VueloRedondo?.IdVueloRedondo,
                    idExtra: idExtra, 
                    idPaquete: vueloTarget?.Proveedor.IdProveedor,
                    suplemento: Number(values.suplemento), 
                    descripcion: planDescripcion,
                    estatus: true
                };

                const dispatchAction = tipo === "regreso"
                    ? actualizarExtraVueloRegresoAction
                    : actualizarExtraVueloAction;

                const extraData = tipo === "regreso" ? extraRegreso : extra;

                dispatch(dispatchAction(extraData)).then((respueta) => {
                    if (respueta?.status === 500) {
                        ToastMessage.fire({
                            icon: "error",
                            title: "Ha habido un problema de conexión con el servidor",
                        });
                        return null
                    }
                    if (respueta?.status === 400) {
                        ToastMessage.fire({
                            icon: "warning",
                            text: respueta?.Message,
                        });
                        return null
                    }
                    setOpen(false);
                    setIsLoad(false);
                    if (tipo === "regreso"){
                        dispatch(obtenerExtrasVueloRegresoAction({ vuelo: vueloTarget?.VueloRedondo.IdVueloRedondo }));
                    } else {
                        dispatch(obtenerExtrasVueloAction({ vuelo: vueloTarget?.IdVueloProveedor }));
                    }
                    ToastMessage.fire({
                        icon: "success",
                        title: "Exito en la operacion",
                    });
                    LimpiarForm();
                })
            break
        }
      })

    }

})

return (
    <div>
        <Tooltip title={`Actualizar extra para vuelo ${tipo === "regreso" ? "regreso" : "ida"}`}>
            <span>
                <Button
                    variant="outlined"
                    color="primary"
                    onClick={handleClickOpen}
                >
                    <EditIcon />
                </Button>
            </span>
        </Tooltip>

        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
            maxWidth='md'
        >
            <form onSubmit={formik.handleSubmit}>
                <HeaderModal
                    titulo="Actualizar Extra"
                    handleClose={handleClose}
                />
                <DialogContent>
                    <Grid container>
                        <Grid item xs={12}>
                            <TextField
                                required
                                id="input-Nombre"
                                label="Nombre"
                                type="text"
                                variant="outlined"
                                name="nombre"
                                value={formik.values.nombre}
                                onChange={formik.handleChange}
                                error={formik.touched.nombre && Boolean(formik.errors.nombre)}
                                helperText={formik.touched.nombre && formik.errors.nombre}
                                className={classes.textField}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                required
                                id="input-Suplemento"
                                label="Suplemento"
                                type="text"
                                variant="outlined"
                                name="suplemento"
                                value={formik.values.suplemento}
                                onChange={formik.handleChange}
                                error={
                                    formik.touched.suplemento &&
                                    Boolean(formik.errors.suplemento)
                                }
                                helperText={
                                    formik.touched.suplemento && formik.errors.suplemento
                                }
                                className={classes.textField}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="start">{vueloTarget?.Moneda?.Clave}</InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <ControlledEditor onValue={onDescripcionValue} onValuePlan={onDescripcionPlanValue} content={descripcion} height="100px" />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions style={{padding: "1rem", paddingRight: "1.5rem"}}>
                    <Button onClick={handleClose} color="secondary" variant="contained">
                        Cancelar
                    </Button>
                    <Button type="submit" color="primary" variant="contained">
                        Agregar
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
        <BackDrop open={isLoad} />
    </div>
)

}

export default ActualizaExtraVuelo;